import api from "../api";
import {commit} from "lodash/seq";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        charge_type: {},
        charge_types: {data: [], current_page: 1, total: 0, per_page: 10},
        loading: false,
        errors: {
            data: {
                errors: {
                    name: [],
                    is_metred: [],
                }
            }
        },
        has_errors: false,
    },
    getters: {
        loading: state => state.loading,
        charge_type: state => state.charge_type,
        dialogVisible: state => state.dialogVisible,
        charge_types: state => state.charge_types,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
    },
    mutations: {
        setLoading(state, val) {
            state.loading = val
        },
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setChargeTypes(state, data) {
            state.charge_types = data;
        },
        setChargeType(state, data) {
            state.charge_type = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            name: [],
                        }
                    }
                };
            }
        }
    },
    actions: {
        async openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },

        async getChargeTypes({commit}, filters) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'charge_type/list', {root: true});
                const response = await api.getChargeTypes(filters);
                commit('setChargeTypes', response);
                commit('setLoading', false)
                commit('deactivateLoading', 'charge_type/list', {root: true});
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },
        async getChargeType({commit}, id) {
            try {
                commit('activateLoading', 'charge_type/list', {root: true});
                const response = await api.getChargeType(id);
                commit('setChargeType', response?.data);
                commit('deactivateLoading', 'charge_type/list', {root: true});
            } catch (e) {
                ElMessage.error("Something went wrong, please try again later.");
            }
        },
        async createChargeType({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                const response = await api.createChargeType(data);
                commit('setChargeType', response?.data);
                dispatch('getChargeTypes', {
                    paginate: true
                })
                ElMessage.success('Charge Type created successfully!');
                return response?.data;
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },
        async editChargeType({dispatch, commit}, data) {
            try {
                commit('setLoading', true);
                await api.editChargeType(data);
                dispatch('getChargeTypes', {
                    paginate: true
                });
                commit('hasErrors', false)
                ElMessage.success('Information updated successfully.');
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },

        async deleteChargeType({dispatch}, data) {
            try {
                await api.deleteChargeType(data);
                dispatch('getChargeTypes', {
                    paginate: true
                })
                ElMessage.success("Charge type removed successfully.")
            } catch (e) {
                if (e.response.status === 422) {
                    ElMessage.error(e.response.data.message)
                } else {
                    ElMessage.error('Error deleting Charge Type');
                }
            }
        }
    }
}
